module.exports = __webpack_public_path__ + "static/media/covidMob1.fc226098.webp";